import { dataCnyWalletSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCnyWalletSolid = /*#__PURE__*/createIcon(dataCnyWalletSolid)
export default IconCnyWalletSolid
